import { render, staticRenderFns } from "./dataWedge.vue?vue&type=template&id=598157b3"
import script from "./dataWedge.vue?vue&type=script&lang=js"
export * from "./dataWedge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports